<template>
  <component :is="component" />
</template>

<script>
  import { mapState } from 'vuex';
  import { termsAndConditionsMap } from '@/brand/setTermsAndConditions';
  import { shallowRef } from 'vue';

  export default {
    name: 'TermsConditionsUi',
    data() {
      return {
        component: undefined
      }
    },
    computed: {
      ...mapState(['brandConfig'])
    },
    beforeMount() {
      const tncs = termsAndConditionsMap.get(this.brandConfig.brand)
      this.component = shallowRef(tncs);
    }
  };
</script>

<style lang='css'>
  @import './index.css';

  .header-text {
    font-size: 30px;
  }

  .terms-conditions-container {
    font-size: 15px;
    height: 80vh;
    overflow: auto;
  }
</style>
